<template>
  <div class="yummable-page">
    <h1>Yummable – The AI-Powered Recipe Explorer</h1>
    <p>Discover recipes from around the world with an interactive map. Whether you're looking for traditional dishes or modern cuisine, yummable makes cooking an exciting journey.</p>

    <div class="yummable-features">
      <div class="feature-card">
        <h3>🌍 Interactive Map</h3>
        <p>Explore dishes from different cultures and find recipes based on location.</p>
      </div>
      <div class="feature-card">
        <h3>🤖 AI-Powered Suggestions</h3>
        <p>Get personalized recipe recommendations based on your taste.</p>
      </div>
      <div class="feature-card">
        <h3>🍳 Step-by-Step Cooking</h3>
        <p>Follow clear, easy-to-understand instructions for every recipe.</p>
      </div>
    </div>

    <div class="download-section">
      <p>Yummable is available in IOS and coming soon to Android! Stay tuned.</p>
    </div>
  </div>
</template>

<style>
.yummable-page {
  text-align: center;
  padding: 60px 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.yummable-page h1 {
  font-size: 40px;
  color: #333;
}

.yummable-page p {
  font-size: 18px;
  color: #555;
  margin-top: 10px;
}

.yummable-features {
  display: flex;
  gap: 20px;
  margin-top: 40px;
  justify-content: center;
}

.feature-card {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 300px;
  text-align: center;
}

.feature-card h3 {
  color: #4A5D23;
}

.download-section {
  margin-top: 40px;
  font-size: 20px;
  font-weight: bold;
  color: #4A5D23;
}
</style>
